import React from "react";
import { formatCurrency } from "../shared/utils";

const Popover = props => {
	return (
		<div className={`popover-content ${props.class !== undefined ? props.class : ""}`}>
			{props.listas.map((lista, i) => {
				return (
					<div key={i} className="values-block">
						{lista.map((item, k) => {
							return (
								<p key={k} className="value-line">
									<span>{item.key}</span>
									<span>{item.value !== null ? formatCurrency(item.value) : "A calcular"}</span>
								</p>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};

export default Popover;
